export default "__VITE_PUBLIC_ASSET__06a4134c__"